import { defineMessages } from 'react-intl';

export default defineMessages({
  accessGroupEditMembershipModalConfirm: {
    defaultMessage: 'Switch to manual',
    id: 'accessGroupEditMembershipModalConfirm',
  },
  accessGroupEditMembershipModalText: {
    defaultMessage:
      'Access groups define which users have access via which devices.{br}{br}Switching to manual membership lets you control exactly who is in this group. Any users you added before will still be here.',
    id: 'accessGroupEditMembershipModalText',
  },
  accessGroupEditMembershipModalTitle: {
    defaultMessage: 'Switch to manual membership',
    id: 'accessGroupEditMembershipModalTitle',
  },
  accessManualGroupFailed: {
    defaultMessage: 'There was an error, please try again',
    description: 'Access snackbar - manual membership switch failed',
    id: 'accessManualGroupFailed',
  },
  accessManualGroupSwitched: {
    defaultMessage: 'Switched to manual membership.',
    description: 'Access snackbar - switched to manual membership',
    id: 'accessManualGroupSwitched',
  },
  buttonsCancel: {
    defaultMessage: 'Cancel',
    id: 'buttons.cancel',
  },
});
